<template>
  <el-dialog
    center
    class="base-drawer"
    :visible.sync="isOpen"
    v-bind="$attrs"
  >
    <slot/>
  </el-dialog>
</template>

<script>
  export default {
    name: 'BaseDialog',
    props: {
      value: { default: false }
    },
    computed: {
      isOpen: {
        get: function() { return this.value },
        set: function(value) { return this.$emit('input', value) },
      }
    }
  }
</script>

<style lang="scss" scoped>
.base-drawer {
  /deep/ {
    .el-dialog {
      margin: 0 !important;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 16px;
    }

    .el-dialog__body {
      padding: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/baseComponents/dialog/BaseDialog.vue